import { type Registry as Services, service } from '@ember/service';
import Model, { attr, belongsTo } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type {
  BeniBreakdownPeriodSegmentDifference,
  BeniBreakdownPeriodSegmentIndex,
  BeniBreakdownPeriodSegmentPickup,
  BeniBreakdownPeriodSegmentRanking,
} from 'lumen/models';
import {
  NUMBER_FORMATS,
  NUMBER_STYLES,
} from 'lumen/utils/constants/benchmark-insight/beni-constant-values';

export default class BeniBreakdownPeriodSegment extends Model {
  [Type] = 'benchmark-insight/breakdown-period-segment' as const;

  // The difference compared to the 'own' comparison set.
  // This is not provided by the API. It is calculated in the frontend when needed.
  // Null for 'own' comparison set.

  @belongsTo('benchmark-insight/breakdown-period-segment-difference', {
    async: false,
    inverse: null,
  })
  declare difference: BeniBreakdownPeriodSegmentDifference;

  // Null for 'own' comparison set.

  @belongsTo('benchmark-insight/breakdown-period-segment-index', {
    async: false,
    inverse: null,
  })
  declare index: BeniBreakdownPeriodSegmentIndex;

  @belongsTo('benchmark-insight/breakdown-period-segment-pickup', {
    async: false,
    inverse: null,
  })
  declare pickup: BeniBreakdownPeriodSegmentPickup;

  // Null for 'own' comparison set.

  @belongsTo('benchmark-insight/breakdown-period-segment-ranking', {
    async: false,
    inverse: null,
  })
  declare ranking: BeniBreakdownPeriodSegmentRanking;

  @attr('number') declare adr: number | null;
  @attr('number') declare occupancy: number | null;
  @attr('number') declare occupancyMix: number | null;
  @attr('number') declare revpar: number | null;

  @service('benchmark-insight/beni-service')
  declare benchmarkInsightBeniService: Services['benchmark-insight/beni-service'];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get formattedAdr() {
    return this.benchmarkInsightBeniService.formatNumber(
      this.adr,
      NUMBER_FORMATS.CURRENCY,
      NUMBER_STYLES.DEFAULT,
    );
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get formattedOccupancy() {
    return this.benchmarkInsightBeniService.formatNumber(
      this.occupancy,
      NUMBER_FORMATS.PERCENTAGE,
      NUMBER_STYLES.DEFAULT,
    );
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get formattedOccupancyMix() {
    return this.benchmarkInsightBeniService.formatNumber(
      this.occupancyMix,
      NUMBER_FORMATS.PERCENTAGE,
      NUMBER_STYLES.DEFAULT,
    );
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get formattedRevpar() {
    return this.benchmarkInsightBeniService.formatNumber(
      this.revpar,
      NUMBER_FORMATS.CURRENCY,
      NUMBER_STYLES.DEFAULT,
    );
  }
}
